document.addEventListener('click', function (e) {
  if (window.DashDebug) return;
  // The Amplitude SDK is only initialised on pages that load its snippet
  // (currently the quiz). Everywhere else this script still runs from the
  // theme layout, so without this guard every tracked click throws.
  if (!window.amplitude || typeof window.amplitude.track !== 'function') return;
  const target = e.target;

  if (
    target.matches('button, a[target="_blank"], a.btn:not([href^="https://butcherboxforpets.com"], [href^="/"]), [data-track-click]')
  ) {
    let btnText = target.textContent || target.getAttribute('alt') || target.getAttribute('id');

    if (!btnText) {
      const img = target.querySelector('img');
      if (img) {
        btnText = img.getAttribute('alt');
      }
    }

    const trackClick = target.dataset.trackClick || btnText;

    const attrs = {};
    Array.from(target.attributes).forEach(attr => {
      attrs[attr.name] = target.getAttribute(attr.name);
    });

    amplitude.track("Clicked Button", {
      text: btnText,
      innerText: target.textContent,
      alt: target.getAttribute('alt'),
      id: target.getAttribute('id'),
      class: target.getAttribute('class'),
      trackClick: trackClick,
      url: window.location.href,
      domain: window.location.host,
      params: window.location.search.substring(1),
      hash: window.location.hash,
      path: window.location.pathname,
      attrs: attrs
    });
  }
});
